/**
 * @file
 * Behaviors for the Carousel.
 */

/* eslint-disable */

!((Drupal, $) => {
  'use strict';

  const VIDEOSPLIT = /(https:\/\/|\/watch\?v=|\/video|\?h=|\/)/;

  function getVideoURL(image) {
    const filter = image
      .split(VIDEOSPLIT)
      .filter(
        (w) =>
          w && w !== 'https://' && w !== '/' && w !== '/watch?v=' && w !== '?h='
      );

    if (filter[0].includes('youtube')) {
      return image;
    }

    if (filter[0].includes('vimeo')) {
      return `https://player.vimeo.com/video/${filter[1]}${
        filter[2] ? `?h=${filter[2]}` : ''
      }`;
    }

    return false;
  }

  function showImagesModal(images, assetIndex) {
    const container = $('<div>', { class: 'asset-modal-portal' });
    if (container) {
      $(document.body).append(container);
      const content = $('<div>', { class: 'asset-modal-portal__content' });
      if (content) {
        container.append(content);
        const carousel = $('<div>', { class: 'asset-modal-portal__carousel' });
        if (carousel) {
          var index = 0;
          const players = [];
          for (const image of images) {
            const assetContainer = $('<div>', {
              class: 'asset-modal-portal__asset-container'
            });

            const videoURL = getVideoURL(image);

            if (videoURL) {
              const video = $('<div>').append(
                $('<iframe>', {
                  src: videoURL
                })
              );

              if (video) {
                carousel.append(assetContainer);
                assetContainer.append(video);
                const player = new Plyr(video, {});
                players.push(player);
              }
            } else {
              const img = $('<img>', {
                class: 'asset-modal-portal__asset',
                src: image
              });

              if (img) {
                carousel.append(assetContainer);
                assetContainer.append(img);
                img.on('load', () => {
                  img.addClass(
                    img.height() > img.width() ? 'portrait' : 'landscape'
                  );
                });
              }
            }

            content.append(carousel);
            setTimeout(() => {
              carousel.slick({
                arrows: true,
                slidesToShow: 1,
                initialSlide: assetIndex
              });

              carousel.on('beforeChange', () => {
                for (const player of players) {
                  player.pause();
                }
              });
            }, 1);

            index++;
          }
        }
      }

      const close = $('<button>', { class: 'asset-modal-portal__close' });
      if (close) {
        container.append(close);
        close.on('click', () => {
          container.remove();
        });
      }
    }
  }

  function initImageModal(context) {
    const imageModals = $('.asset-modal', context).not(
      '.asset-modal--initialized'
    );
    const tolerance = 10;

    if (imageModals) {
      for (const imageModal of imageModals) {
        try {
          const modal = $(imageModal);
          const images = JSON.parse(modal.attr('data-images'));
          const thumbnails = JSON.parse(modal.attr('data-thumbnails'));

          if (Array.isArray(images) && images.length) {
            const drag = { x: -1, y: -1, d: false };
            modal
              .addClass('asset-modal--initialized')
              .on('mousedown', (e) => {
                drag.x = e.pageX;
                drag.y = e.pageY;
                drag.d = false;
              })
              .on('mousemove', (e) => {
                if (drag.d) return;
                drag.d =
                  Math.abs(e.pageX - drag.x) > tolerance ||
                  Math.abs(e.pageY - drag.y) > tolerance;
              })
              .on('click', (e) => {
                if (!drag.d || (drag.x === -1 && drag.y === -1)) {
                  showImagesModal(
                    images,
                    thumbnails.indexOf(
                      e.target.src.replace(/https?:\/\/[^\/]+/i, '')
                    ) || 0
                  );
                }
              });
          }
        } catch (ex) {}
      }
    }
  }

  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  if (Drupal && !(Drupal.behaviors && Drupal.behaviors.imageModal)) {
    Drupal.behaviors.imageModal = {};
    Drupal.behaviors.imageModal.attach = function(context) {
      initImageModal(context);
    };
  }
})(Drupal, jQuery);
